/* eslint-disable max-classes-per-file */
import {
  Component,
  ContentChild,
  Directive,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Directive({
  selector: 'ng-template[wlModalBody]',
  standalone: true,
})
export class ModalBodyDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}

@Directive({
  selector: 'ng-template[wlModalFooter]',
  standalone: true,
})
export class ModalFooterDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}

@Component({
  selector: 'wl-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.essent.scss', './modal.component.ed.scss'],
  standalone: true,
  imports: [NgClass, NgTemplateOutlet],
})
export class ModalComponent {
  @ContentChild(ModalBodyDirective, { static: true })
  body?: ModalBodyDirective;
  @ContentChild(ModalFooterDirective, { static: true })
  footer?: ModalFooterDirective;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() modalTitle?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() autoCloseTime?: number;

  @Output()
  closeModal = new EventEmitter<void>();
  @Output()
  clickModal = new EventEmitter<void>();

  handleClick() {
    this.clickModal.emit();
    this.closeModal.emit();
  }
}
